export const TICKET = 'TICKET'